export default "__VITE_PUBLIC_ASSET__b9c3b700__"